// @ts-check
import { alhondigas } from './configs/alhondigas';
import { appOrders } from './configs/appOrders';
import { common } from './configs/common';
import { contracts } from './configs/contracts';
import { dumping } from './configs/dumping';
import { expeditions } from './configs/expeditions';
import { picking } from './configs/picking';
import { presence } from './configs/presence';
import { repairParts } from './configs/repairParts';
import { traceability } from './configs/traceability';
import { warehouse } from './configs/warehouse';
import { defineConfig } from './helpers';

// [!] Here go all the parameters. If the category is not included here, the parameters
// from that category will not be loaded.
export const params = defineConfig({
  ...alhondigas(),
  ...appOrders(),
  ...common(),
  ...contracts(),
  ...dumping(),
  ...expeditions(),
  ...picking(),
  ...presence(),
  ...repairParts(),
  ...traceability(),
  ...warehouse(),
});

/** @typedef {typeof params} Parameters */
/** @typedef {keyof Parameters} ParameterKeys */
